export const AREA_TOP_MARGIN = [7, 7, 10];
export const AREA_BOTTOM_MARGIN = [7, 7, 10];
export const TOP_MARGIN_CONTENT_APP = 2;
export const TOP_MARGIN_NAV_LESS_PAGE = 0;
